import React from "react";
import Contact from "../components/Contact";

function Contactpage() {
  return <Contact />;
}

export default Contactpage;
